<template>
  <div class="wrapper inner">
    <button
      class="back-btn"
      type="button"
      @click.prevent="$emit('on-click-back')"
    >
      <span class="a11y-hidden">뒤로가기</span>
      <Arrow-Left :color="tonal.white.white" />
    </button>

    <h2 class="title" :style="{ color: tonal?.white.white }">
      {{ props.title }}
    </h2>

    <w-select
      v-if="hasSubCategoryFilter"
      :options="props.options"
      :placeholder="props.default"
      @selected="handleSelected"
    />
  </div>
</template>

<script setup>
  import { computed, defineProps } from 'vue'
  import { useRouter, useRoute } from 'vue-router/composables'
  import { tonal } from '@/constants/tonal'
  import { ON_CLICK } from '@/common/event.const'
  import { EventBus } from '@/components/eventbus/EventBus'

  import { ArrowLeft } from '@/components/Icons'
  import WSelect from '@/components/ui/Select'

  const route = useRoute()
  const router = useRouter()

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    default: {
      type: String,
      default: '',
    },
  })

  const mainCode = computed(() => route?.query.mainCode?.toUpperCase() ?? '')
  const hasSubCategoryFilter = computed(() => (props.options?.length ?? 0) > 1)

  const handleSelected = (event) => {
    if (!event) return

    const [onClick] = event.option.eventlist
    EventBus.$emit(ON_CLICK, onClick)

    router.push({
      path: '/category/sub',
      query: { mainCode: mainCode.value, subCode: event.option.value },
    })
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: rgb(27, 27, 27);
  }

  .inner {
    max-width: 1240px;
    margin: 0 auto;
    .back-btn {
      font-size: 0;
      padding: 16px 0 16px 16px;
    }
    .title {
      display: block;
      font-size: 16px;
      line-height: 24px;
    }
  }
</style>
